import React, { lazy, useCallback, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import {
  Button,
  Input,
  SubTitle,
} from "../../Components/CustomComponents/index.js";
import SimpleTable from "../../Components/Table/SimpleTable.js";
import Pagination from "../../Components/Pagination/Pagination.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";

//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { debounce } from "lodash";
import moment from "moment";
import { Badge, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { MdOutlineDone } from "react-icons/md";
import { RxCross1 } from "react-icons/rx";
import { useGetAllTxnHistoryQuery } from "../../Data/services/transactionApi.js";
import CustomLoader from "../../Components/CustomComponents/CustomLoader.js";

const CustomerBlockModal = lazy(() =>
  import("../../Components/Modals/CustomerBlockModal.js")
);

const TransactionHistoryScreen = ({ setPage }) => {
  const dispatch = useDispatch();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);

  const [loading, setLoading] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [orderBy, setOrderBy] = useState("createdAt");
  const [order, setOrder] = useState("DESC");

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllTxnHistoryQuery(
      {
        search: searchQuery.length >= 3 ? searchQuery : "",
        start_date: startDate != null ? startDate : "",
        end_date: endDate != null ? endDate : "",
        limit: pageSize,
        page: currentPage,
        orderBy: orderBy,
        order: order,
      },
      { refetchOnMountOrArgChange: true }
    );

  useEffect(() => {
    if (data) {
      // console.log(data);
      setPageSize(data.links.per_page);
      setCurrentPage(data.links.current);
      setTotalRecords(data.links.total_records);
      setTotalPages(data.links.total);
      setRowData(data.data);
      setDataFetched(true);

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data]);

  // const debouncedSearch = useCallback(
  //   debounce((query) => {
  //     console.log("Search query:", query);
  //     // local search logic
  //     const filtered = dummy_data.filter((item) =>
  //       [item.firstname, item.lastname, item.username, item.email]
  //         .filter(Boolean) // Remove null/undefined fields
  //         .some((field) => field.toLowerCase().includes(query.toLowerCase()))
  //     );

  //     setRowData(filtered);

  //     // Trigger your search logic or API here
  //   }, 500), // Adjust debounce delay as needed
  //   []
  // );

  const handleFilter = () => {
    // Trigger refetch when dates change
    if (refetch) {
      refetch();
    }
  };

  // Auto-refetch when dates change
  useEffect(() => {
    if (startDate || endDate) {
      const timeoutId = setTimeout(() => {
        if (refetch) {
          refetch();
        }
      }, 500); // Debounce the API call
      
      return () => clearTimeout(timeoutId);
    }
  }, [startDate, endDate, refetch]);

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "name",
      text: "Name",
      // sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        const username = `${row.user.firstname || ''} ${row.user.lastname || ''}`.trim();
        return (
          <div className="d-flex flex-row justify-content-start align-items-center gap-2">
            <div className="d-flex flex-column">
              <div className="fw-semibold text-dark" style={{fontSize: '0.8rem', lineHeight: '1.2'}}>
                {username || 'N/A'}
              </div>
              <div className="text-muted" style={{fontSize: '0.7rem', lineHeight: '1.1'}}>
                ID: {row.user.id || 'N/A'}
              </div>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "email",
      text: "Email",
      // sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex align-items-center gap-1">
            <i className="bi bi-envelope text-muted" style={{fontSize: '0.7rem'}}></i>
            <span className="text-wrap-custom" style={{fontSize: '0.75rem', lineHeight: '1.2'}}>
              {row.user.email || 'N/A'}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "gateway_transaction_id",
      text: "Txn Id",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "140px",
      },
      formatter: (cellContent, row) => {
        const txnId = row.gateway_transaction_id || 'N/A';
        const shortId = txnId.length > 12 ? `${txnId.substring(0, 12)}...` : txnId;
        
        return (
          <div className="d-flex align-items-center justify-content-center gap-1">
            <i className="bi bi-receipt text-primary" style={{fontSize: '0.7rem'}}></i>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id="txn-tooltip">
                  {txnId}
                </Tooltip>
              }
            >
              <Badge 
                pill 
                bg="primary" 
                className="px-2 py-1 cursor-pointer" 
                style={{fontSize: '0.7rem', lineHeight: '1.1', maxWidth: '120px'}}
              >
                {shortId}
              </Badge>
            </OverlayTrigger>
          </div>
        );
      },
    },
    {
      dataField: "transaction_amount",
      text: "Amount",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex align-items-center justify-content-center gap-1">
            <i className="bi bi-currency-dollar text-success" style={{fontSize: '0.7rem'}}></i>
            <span className="fw-semibold text-success" style={{fontSize: '0.8rem', lineHeight: '1.2'}}>
              {row.transaction_amount || '0.00'}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "is_tip",
      text: "Tip",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        if (row.is_tip) {
          return (
            <div className="d-flex align-items-center justify-content-center gap-1">
              <i className="bi bi-check-circle text-success" style={{fontSize: '0.7rem'}}></i>
              <span className="text-success" style={{fontSize: '0.75rem', lineHeight: '1.2'}}>Yes</span>
            </div>
          );
        } else {
          return (
            <div className="d-flex align-items-center justify-content-center gap-1">
              <i className="bi bi-x-circle text-danger" style={{fontSize: '0.7rem'}}></i>
              <span className="text-danger" style={{fontSize: '0.75rem', lineHeight: '1.2'}}>No</span>
            </div>
          );
        }
      },
    },
    {
      dataField: "status",
      text: "Txn Status",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        if (row.status === "pending") {
          return (
            <div className="d-flex align-items-center justify-content-center gap-1">
              <i className="bi bi-clock text-warning" style={{fontSize: '0.7rem'}}></i>
              <span className="text-warning text-capitalize" style={{fontSize: '0.75rem', lineHeight: '1.2'}}>Pending</span>
            </div>
          );
        } else if (row.status === "completed" || row.status === "success") {
          return (
            <div className="d-flex align-items-center justify-content-center gap-1">
              <i className="bi bi-check-circle text-success" style={{fontSize: '0.7rem'}}></i>
              <span className="text-success text-capitalize" style={{fontSize: '0.75rem', lineHeight: '1.2'}}>Completed</span>
            </div>
          );
        } else {
          return (
            <div className="d-flex align-items-center justify-content-center gap-1">
              <i className="bi bi-exclamation-circle text-danger" style={{fontSize: '0.7rem'}}></i>
              <span className="text-danger text-capitalize" style={{fontSize: '0.75rem', lineHeight: '1.2'}}>{row.status}</span>
            </div>
          );
        }
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      onSort: (field, order) => {
        setOrderBy("createdAt");
        setOrder(order === "desc" ? "DESC" : "ASC");
      },
      formatter: (cellContent, row) => {
        const agoFormat = moment(row.created_at).fromNow();
        const fullDate = moment(row.created_at).format("MMM DD, YYYY");
        return (
          <div className="d-flex align-items-center justify-content-center gap-1">
            <i className="bi bi-calendar3 text-muted" style={{fontSize: '0.7rem'}}></i>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip(row.created_at)}
            >
              <div className="d-flex flex-column align-items-center">
                <span className="text-muted" style={{fontSize: '0.7rem', lineHeight: '1.1'}}>{agoFormat}</span>
                <span className="text-dark" style={{fontSize: '0.65rem', lineHeight: '1.1'}}>{fullDate}</span>
              </div>
            </OverlayTrigger>
          </div>
        );
      },
    },
  ];

  return (
    <div className={styles.MainContainer}>
      <div className={styles.headerContainer}>
        <Row className="w-100 align-items-center">
          <Col md={6}>
            <div>
              <SubTitle text={"Transaction History"} classes="text-black" />
            </div>
          </Col>

          <Col md={6}>
            <div className={`d-flex flex-column flex-md-row gap-3 ${styles.dateFilterContainer}`}>
              <div className={styles.dateInputContainer}>
                <label className="form-label small text-muted mb-1">From Date</label>
                <Input
                  type="date"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className={styles.dateInput}
                />
              </div>
              <div className={styles.dateInputContainer}>
                <label className="form-label small text-muted mb-1">To Date</label>
                <Input
                  type="date"
                  placeholder="End Date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className={styles.dateInput}
                />
              </div>
            </div>
          </Col>
        </Row>

        {
          // <Row>
          //   <Col md={12}>
          //     <Button
          //       classes={`${styles.cardBtn} `}
          //       text="Add User"
          //       onClick={handleAddUser}
          //     ></Button>
          //   </Col>
          // </Row>
        }
      </div>

      <div className={styles.mainTable}>
        {!dataFetched || !isSuccess ? (
          <CustomLoader />
        ) : (
          <div className={styles.mainTable}>
            <div className={styles.tableContent}>
              <SimpleTable
                data={rowData}
                columns={columns}
                indication={indication}
                totalRecords={totalRecords}
                totalPages={totalPages}
                pageSize={pageSize}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                refetch={refetch}
                showPagination={false}
              />
            </div>
          </div>
        )}

        {/* Pagination outside the table div */}
        {dataFetched && isSuccess && totalPages > 1 && (
          <div className={styles.paginationWrapper}>
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalRecords={totalRecords}
              pageSize={pageSize}
              onPageChange={(page) => {
                setCurrentPage(page);
                if (refetch) {
                  refetch();
                }
              }}
              onPageSizeChange={(newSize) => {
                setPageSize(newSize);
                setCurrentPage(1);
                if (refetch) {
                  refetch();
                }
              }}
              showPageSizeSelector={true}
              showRecordsInfo={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const renderTooltip = (date) => (
  <Tooltip id="button-tooltip">
    {moment(date).format("YYYY-MM-DD HH:mm:ss")}
  </Tooltip>
);

export default TransactionHistoryScreen;
